import React from "react";
import { Button, Result } from "antd";

/**
 * Catches render errors in child trees (including lazy route modules).
 * Does not catch errors in event handlers, async work, or errors in the boundary itself.
 */
export default class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (typeof this.props.onError === "function") {
      this.props.onError(error, errorInfo);
    } else {
      console.error("GlobalErrorBoundary:", error, errorInfo);
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      const fallback = this.props.fallback;
      if (fallback) {
        return typeof fallback === "function"
          ? fallback({ error: this.state.error, reset: this.handleReset })
          : fallback;
      }

      return (
        <div
          style={{
            minHeight: "60vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 24,
          }}
        >
          <Result
            status="error"
            title="Something went wrong"
            subTitle="This screen crashed. You can try again or reload the page."
            extra={[
              <Button type="primary" key="retry" onClick={this.handleReset}>
                Try again
              </Button>,
              <Button key="reload" onClick={this.handleReload}>
                Reload page
              </Button>,
            ]}
          />
        </div>
      );
    }

    return this.props.children;
  }
}
